/**
 * <Eyebrow> — small caps section label, optional leading dot.
 *
 * Pattern: every section heading in the PolicyOra design language is
 * pre-introduced by an eyebrow chip (small caps, letter-spaced).
 *
 *   ● GLOBAL POLICY INTELLIGENCE     (dot variant)
 *     KEY CAPABILITIES               (plain variant)
 *     WELCOME BACK                   (teal variant — used in form panels)
 */
import React from 'react';
import styles from './Eyebrow.module.css';

export type EyebrowTone = 'default' | 'teal' | 'blue' | 'orange';

interface EyebrowProps {
  children: React.ReactNode;
  dot?: boolean;
  tone?: EyebrowTone;
  className?: string;
}

export const Eyebrow: React.FC<EyebrowProps> = ({
  children,
  dot = false,
  tone = 'default',
  className = '',
}) => {
  return (
    <span className={`${styles.eyebrow} ${styles[`tone_${tone}`]} ${className}`}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  );
};
